export const SHOW_MODAL = 'modal/SHOW'
export const HIDE_MODAL = 'modal/HIDE'



// WEBPACK FOOTER //
// ./state/types/modal.js